import React from 'react';
import { Avatar, AvatarFallback } from '~/lib/ui/avatar';
import { cn } from '~/lib/utils';
import { useActionListContext } from '../../context';
import { ActionListItemProps } from './index.types';

const ActionListItem = ({
  children,
  className,
  onClick,
  text,
  hasAvatar,
  testID,
  isSelected = false,
  ...props
}: ActionListItemProps) => {
  const context = useActionListContext();
  const baseTestID = testID || context?.testID;
  const componentTestId = baseTestID
    ? `${baseTestID}-action-list-item`
    : 'action-list-item';

  const classes = cn(
    'flex flex-row items-center gap-2 p-2 rounded-lg hover:bg-muted',
    onClick && 'cursor-pointer',
    isSelected && 'bg-accent',
    className
  );

  return (
    <div
      data-slot="action-list-item"
      onClick={onClick}
      data-testid={componentTestId}
      className={classes}
      role="option"
      aria-selected={isSelected}
      {...props}
    >
      {text ? (
        <>
          {hasAvatar && (
            <div className="flex-shrink-0">
              <Avatar className="w-6 h-6 flex-shrink-0">
                <AvatarFallback name={text} />
              </Avatar>
            </div>
          )}
          <p className="text-sm font-normal text-foreground truncate min-w-0">
            {text}
          </p>
        </>
      ) : (
        children
      )}
    </div>
  );
};

export default ActionListItem;
